import React from 'react';
import { Spinner as RadixSpinner } from '@radix-ui/themes';

const Spinner = ({ size = 'medium' }) => {
  const sizeMap = { small: '1', medium: '2', large: '3' };

  return (
    <div className="flex items-center justify-center">
      <RadixSpinner size={sizeMap[size] || '2'} />
    </div>
  );
};

export default Spinner;
